document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', (e) => {

        const targetId = link.getAttribute('href');
        if (targetId.startsWith("#")) {

            // Prevent URL jump
            e.preventDefault();

            history.replaceState(null, '', window.location.pathname + window.location.search);

            const targetElement = document.getElementById(targetId.slice(1));

            targetElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });

        }
    });
});